import { CopyFilled } from "@ant-design/icons";
import { Skeleton } from "antd";
import React from "react";
import { usePersonal } from "../../pages/Personal/context/PersonalContext";
import VIPIcon from "../VIPIcon";
import { BalanceViewer, PersonalMenu } from "./components";
import styles from "./styleModule";
const AccountInfoPersonal = ({
  customAccountInfoStyle = "",
  customAccountStyle = "",
  customUidStyle = "",
  customBalanceContainer = "",
  customBalanceSubContainer = "",
  customBalanceTitle = "",
  customBalanceBackground = "",
  customCurvedBackground = "",
  balanceCurvedBackground = "",
  balanceCurvedWrapper = "",
  customMenuContainerStyle = "",
  customBalanceTextStyle = "",
  menuItemContainerStyle = "",
  columns = 0,
  menuItems = [],
  rightBoxIconEnum = [],
  customMenuTitleStyle = "",
  customTitleStyle = "",
  menuGap = [0, 0],
}) => {
  const { isLoading, userIconId, data: userInfo, handleCopy, navigate } = usePersonal();
  return (
    <div className={styles.container}>
      <div className={`${styles.accountInfo} ${customAccountInfoStyle}`}>
        {isLoading ? (
          <>
            <Skeleton.Avatar active />
            &nbsp;
            <Skeleton.Input active size={"small"} block />
          </>
        ) : (
          <>
            <div className={`${styles.leftBox}`}>
              <img
                src={`/images/avatar/avatar${userIconId}.png`}
                alt="avatar"
                className={`${styles.userIcon}`}
              />
              <div className={`${styles.emailBox}`}>
                <div className={styles.accountContainer}>
                  <div className={`${styles.account} ${customAccountStyle}`}>
                    {userInfo?.account}
                  </div>
                  <div className={styles.copyIcon} onClick={() => handleCopy(userInfo?.account)}>
                    <CopyFilled />
                  </div>
                </div>
                <div className={styles.uidContainer}>
                  <div
                    className={`${styles.uid} ${customUidStyle}`}
                  >{`ID: ${userInfo?.account_id}`}</div>
                  <div className={styles.copyIcon} onClick={() => handleCopy(userInfo?.account_id)}>
                    <CopyFilled />
                  </div>
                </div>
              </div>
            </div>
            <div
              className={`${styles.vipLabelBox}`}
              onClick={() => {
                // if (window.location.pathname === "/bonus") return;
                // navigate("/bonus?tab=vip");
                navigate("/vip");
              }}
            >
              {/* <div className={`${styles.vipLabel}`}> */}
              {/* <img src={``} alt="" className={`${styles.vipIcon}`} /> */}
              <VIPIcon vipLevel={userInfo?.level_name} imageStyle={styles.vipImageStyle} />
              {/* {userLevel} */}
              {/* </div> */}
            </div>
          </>
        )}
      </div>
      <div className={`${customBalanceBackground}`}>
        <BalanceViewer
          customBalanceTitle={customBalanceTitle}
          customBalanceContainer={customBalanceContainer}
          customBalanceSubContainer={customBalanceSubContainer}
          customBalanceTextStyle={customBalanceTextStyle}
        />
        <PersonalMenu
          menuItems={menuItems}
          columns={columns}
          menuItemContainerStyle={menuItemContainerStyle}
          customMenuTitleStyle={customMenuTitleStyle}
          customTitleStyle={customTitleStyle}
          customMenuContainerStyle={customMenuContainerStyle}
          menuGap={menuGap}
        />
      </div>

      <div className={styles.wrapper}>
        <div className={`${styles.background} ${customCurvedBackground}`} />
      </div>
    </div>
  );
};

export default AccountInfoPersonal;
